import { render, staticRenderFns } from "./ProjectSettingsPanel.vue?vue&type=template&id=1ef99ee6&scoped=true&"
import script from "./ProjectSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef99ee6",
  null
  
)

export default component.exports